export default __webpack_public_path__ + "static/media/standsExpo_condumex.41aa6ef1.jpg";